// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/astroturf/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  ._3W5IvxPia75NSEZmFXoBmA {\n    display: flex;\n    flex-direction: column;\n  }\n  ._3W5IvxPia75NSEZmFXoBmA textarea {\n    height: 400px;\n    outline: none;\n    border: none;\n  }\n  ._3N02lA9zkh_pv4M7FdSKFQ {\n    font-family: Helvetica serif;\n    font-size: 24px;\n    color: white;\n    padding: 8px;\n  }\n  ._1QtaoYNAGXwdUqEuaQejp4 {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin: 12px 24px;\n  }\n", ""]);
// Exports
exports.locals = {
	"editor": "_3W5IvxPia75NSEZmFXoBmA",
	"name": "_3N02lA9zkh_pv4M7FdSKFQ",
	"actions": "_1QtaoYNAGXwdUqEuaQejp4"
};
module.exports = exports;
